import { request } from "../../utils/AxiosInstance";

export const HistoryFormApi = async (params) => {
  const params1 = params.queryKey[1];
  return request({ url: "history", params: params1 });
};
